export const LAST_CLOSED_SALE_BANNER_STORAGE_KEY = 'last_closed_sale_banner';
